import { Check } from "lucide-react";

const HIGHLIGHTS = [
  "Atención personalizada en cada proyecto",
  "Equipo especializado por tipo de trabajo",
  "Materiales de calidad y prolijidad en cada detalle",
  "Comunicación clara y compromiso con los plazos",
];

export default function About() {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="relative bg-[var(--fb-bg)] py-20 md:py-32"
    >
      <div className="fb-container grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5 reveal">
          <span className="eyebrow">Nosotros</span>
          <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl text-[var(--fb-ink)] font-medium tracking-tight balance leading-[1.02]">
            Una constructora que se involucra
            <span className="text-[var(--fb-accent)]">.</span>
          </h2>
          <div className="mt-8 hidden lg:block">
            <div className="relative overflow-hidden rounded-2xl aspect-[4/5]">
              <img
                src="/photos/exterior_04.jpg"
                alt="Trabajo de fachada y alero terminado"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 reveal" style={{ transitionDelay: "120ms" }}>
          <div className="space-y-5 text-[var(--fb-ink-soft)] text-base md:text-[17px] leading-[1.75] pretty max-w-[58ch]">
            <p>
              En <strong className="text-[var(--fb-ink)]">Florentin Contractors</strong>{" "}
              nos dedicamos a transformar ideas en obras concretas. Trabajamos en
              construcción general, refacciones, remodelaciones y pérgolas, con
              una mirada cercana al cliente y un fuerte compromiso con la
              prolijidad de cada terminación.
            </p>
            <p>
              Contamos con equipos especializados según el tipo de proyecto. Esto
              nos permite asignar a las personas indicadas en cada etapa, cuidar
              los tiempos y mantener un estándar de calidad uniforme, desde la
              primera reunión hasta la entrega final.
            </p>
            <p>
              Creemos en la honestidad de la mano de obra y en la importancia de
              que cada cliente entienda lo que se hace en su obra. Por eso
              ofrecemos presupuestos claros, comunicación constante y atención
              personalizada en cada paso.
            </p>
          </div>

          <ul className="mt-10 grid sm:grid-cols-2 gap-3.5">
            {HIGHLIGHTS.map((h, i) => (
              <li
                key={i}
                className="flex items-start gap-3 bg-white border border-[var(--fb-line)] rounded-xl px-4 py-3.5 reveal"
                style={{ transitionDelay: `${180 + i * 60}ms` }}
                data-testid={`about-highlight-${i}`}
              >
                <span className="mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-[var(--fb-ink)] text-white shrink-0">
                  <Check className="h-3.5 w-3.5" strokeWidth={3} />
                </span>
                <span className="text-sm md:text-[15px] text-[var(--fb-ink-soft)] font-medium leading-snug">
                  {h}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
